import { MDBBtn, MDBIcon, MDBModalFooter } from "mdb-react-ui-kit";
import React, { useState } from "react";
import uploadIcon from "../../../components/images/upload.svg";
import {
  portingSteps,
  portingStepsForm,
} from "../../../apiclients/streamsapi_bridge";

function UPloadCopyOfBill({
  handleNext,
  currentStep,
  handleBack,
  uploadedFiles,
  setUploadedFiles,
  maxNumFileUpload,
  setflowStep,
  nextPageclick,
  flowStep,
  handleSubmit,
  formState,
  setError,
  portingType,
  setUploadedOldFiles,
  uploadedOldFiles,
  selectedFiles,
  setselectedFiles,
  setbackFlag,
  setorderID,
  setSuccessMessage,
  setsavedDraftData,
  isChanged,
  orderID,
  setdeletedFiles,
  deletedFiles,
}) {
  console.log(
    "uploadedFiles :::::::::old ::::: " + JSON.stringify(uploadedOldFiles)
  );
  const handleDeleteFile = (index) => {
    const newUploadedFiles = [...uploadedFiles];
    newUploadedFiles.splice(index, 1);
    setUploadedFiles(newUploadedFiles);
    setselectedFiles(newUploadedFiles);
  };
  const handleDeleteOldFile = (index, id) => {
    // const newUploadedFiles = [...uploadedOldFiles];
    // newUploadedFiles.splice(index, 1);
    // setUploadedOldFiles(newUploadedFiles);
    const newUploadedFiles = [...uploadedOldFiles];
    newUploadedFiles.splice(index, 1);
    setUploadedOldFiles(newUploadedFiles);
    let deleteFilesList =
      deletedFiles && deletedFiles.length > 0
        ? deletedFiles.filter((file) => parseInt(file) !== parseInt(id))
        : [];
    setdeletedFiles([...deleteFilesList, id]);
  };

  const handleFileChange = (event) => {
    const files = Array.from(event.target.files);
    const oldUploadedFiles = [...selectedFiles]; // Copy existing files
    const existingFiles = oldUploadedFiles.map((file) => file.name);
    const duplicates = files.filter((file) =>
      existingFiles.includes(file.name)
    );
    const dbfiles = uploadedOldFiles.map((file) => file.file_name);
    const oldduplicate = files.filter((file) => dbfiles.includes(file.name));

    if (duplicates && duplicates.length > 0) {
      const name = duplicates.map((file) => file.name);
      alert(`Files ${name.join(", ")} are duplicate`);
      return;
    } else if (oldduplicate && oldduplicate.length > 0) {
      const name = oldduplicate.map((file) => file.name);
      alert(`Files ${name.join(", ")} are duplicate`);
      return;
    }
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      if (file.type !== "application/pdf") {
        alert(`Upload only PDF File.`);
        return;
      }
      console.log(
        "uploadedFiles.length ::::::::::: " + oldUploadedFiles.length
      );
      if (oldUploadedFiles.length + files.length > 10) {
        alert("Maximum 10 PDF files can be uploaded.");
        return;
      }
      const fileSizeInMB = file.size / (1024 * 1024); // Convert bytes to MB

      if (fileSizeInMB <= 25) {
        oldUploadedFiles.push(file);
        // Check if file size is within limit
      } else {
        alert(`File '${file.name}' exceeds the maximum file size of 25 MB.`);
      }
    }
    setselectedFiles(oldUploadedFiles);

    setUploadedFiles(oldUploadedFiles);
  };

  function handleForNext() {
    setflowStep(parseInt(flowStep) + 1);
    nextPageclick();
  }

  const { dirtyFields, isDirty, errors } = formState;

  const handleSaveDraft = async (data) => {
    if (Object.keys(dirtyFields).length > 0) {
      const formData = new FormData();
      formData.append(
        "siteid",
        JSON.parse(sessionStorage.getItem("admin_session")).siteid
      );
      formData.append(
        "reqid",
        parseInt(portingType) === 1 ? 91 : parseInt(portingType) === 2 ? 95 : 96
      );
      formData.append("port_type", parseInt(portingType));
      formData.append("flow_step", parseInt(flowStep));
      formData.append("save_as_draft", true);
      if (orderID) {
        formData.append("orderid", orderID);
      }
      for (const field of Object.keys(dirtyFields)) {
        if (
          (field === "notifs_comments" || field === "assign") &&
          portingType === 3
        )
          continue;
        let modifiedData = {};
        if (dirtyFields[field] && data.hasOwnProperty(field)) {
          if (typeof data[field] === "object" && !Array.isArray(data[field])) {
            for (const subfield of Object.keys(dirtyFields[field])) {
              if (data[field].hasOwnProperty(subfield)) {
                modifiedData[subfield] = data[field][subfield];
              }
            }
            if (field === "acc_info" && portingType === 2) {
              modifiedData.porting_num_type = data[field]["porting_num_type"];
            }
            if (field === "notifs_comments") {
              modifiedData.send_email_to_admin =
                data[field]["send_email_to_admin"];
            }

            if (field !== "checklist") {
              formData.append(field, JSON.stringify(modifiedData));
            }
          } else {
            modifiedData = [...data[field]];
            formData.append(field, JSON.stringify(modifiedData));
          }
        }
      }
      if (portingType !== 3) {
        formData.append("checklist", JSON.stringify(data.checklist));
      }
      if (uploadedFiles && uploadedFiles.length > 0) {
        uploadedFiles.forEach((file) => {
          formData.append("upload_latest_bill", file, file.name);
        });
      }
      if (deletedFiles && deletedFiles.length > 0) {
        // uploadedOldFiles.forEach((files) => {
        formData.append("deletepdfs", deletedFiles);
        // });
      }
      let saverep = await portingStepsForm(formData);
      console.log(`reponse of next :::: ${JSON.stringify(saverep)}`);
      let saverepeMsg = await saverep.json();
      console.log("response of next:::" + JSON.stringify(saverepeMsg));

      if (saverepeMsg.status && saverepeMsg.status == "success") {
        setsavedDraftData(data);
        setSuccessMessage(saverepeMsg.message);
        if (saverepeMsg?.orderid) {
          setorderID(saverepeMsg?.orderid);
        }
      } else {
        if (saverepeMsg.message?.errors) {
          saverepeMsg.message.errors.forEach((err) => {
            setError(err.param_name, {
              type: "server",
              message: err.message,
            });
            const fieldElement = document.querySelector(
              `input[name="${err.param_name}"]`
            );
            if (fieldElement) {
              fieldElement.focus();
              fieldElement.scrollIntoView({ behavior: "smooth" });
            }
          });
        } else {
          //   setInternalError(true);
        }
      }
      // }
    }
  };

  return (
    <>
      <div className="file-uploader-container">
        <div className="d-flex align-items-center justify-content-center p-3 flex-column">
          <h5>Upload Latest Copy of Bill or Customer Service Record</h5>
          {/* <div className="uploadOuter mt-3 w-80">
                                        <span className="dragBox2 upload-content" >
                                            <span>
                                                <img src={uploadIcon} className="upload-img" />
                                            </span>
                                            <span>Drag and Drop to upload Files</span>
                                            <small className="text-secondary mt-2">Maximum of 5 PDF files (Max file size: 25 MB) can be uploaded!</small>
                                            <input
                                                type="file"
                                                id="uploadFile"
                                                className="upload__img LOA"
                                            />
                                        </span>
                                    </div> */}
          <div className="uploadOuter mt-3 w-80 sm-w-100 my-3">
            <span className="dragBox2 upload-content w-60 sm-w-100">
              <span>
                <img
                  src={uploadIcon}
                  className="upload-img"
                  alt="Upload Icon"
                />
              </span>
              <span>Drag and Drop to upload Files</span>
              <small className="text-secondary mt-2">
                Maximum of 10 PDF files (Max file size: 25 MB) can be uploaded!
              </small>
              <input
                type="file"
                id="uploadFile"
                className="upload__img LOA"
                onChange={handleFileChange}
                multiple
                accept=".pdf"
              />
            </span>
          </div>
          <div className="w-80 sm-w-100 listOfFiles">
            {uploadedFiles.length > 0 && (
              <div className="d-flex  align-items-center justify-content-center flex-column">
                {uploadedFiles.map((fileinfo, index) => (
                  <div className="border p-2 px-3 mt-2 rounded bg-light w-60 sm-w-100 d-flex align-items-center justify-content-between">
                    <span>{fileinfo.name}</span>
                    <MDBIcon
                      fas
                      icon="times"
                      className="cursor-pointer"
                      onClick={() => handleDeleteFile(index)}
                    />
                  </div>
                ))}
              </div>
            )}
            {uploadedOldFiles && uploadedOldFiles.length > 0 && (
              <div className="d-flex  align-items-center justify-content-center flex-column">
                {uploadedOldFiles.map((fileinfo, index) => (
                  <div className="border p-2 px-3 mt-2 rounded bg-light w-60 sm-w-100 d-flex align-items-center justify-content-between">
                    <span>{fileinfo.file_name}</span>
                    <MDBIcon
                      fas
                      icon="times"
                      className="cursor-pointer"
                      onClick={() =>
                        handleDeleteOldFile(index, fileinfo.fileid)
                      }
                    />
                  </div>
                ))}
              </div>
            )}
          </div>
          <p className="mt-2">
            <b>Note: </b>
            Please upload the latest copy of Bill for the added phone number(s)
            that can evidence that you own the phone number(s).
          </p>
        </div>
      </div>

      <MDBModalFooter className="d-flex justify-content-between">
        {((selectedFiles && selectedFiles.length > 0) ||
          (deletedFiles && deletedFiles.length > 0) ||
          (uploadedOldFiles && uploadedOldFiles.length > 0)) && (
            <>
              {((selectedFiles && selectedFiles.length > 0) ||
                (deletedFiles && deletedFiles.length > 0)) && (
                  <>
                    <MDBBtn
                      color="secondary"
                      className="text-normal-case"
                      onClick={(e) => {
                        e.preventDefault();
                        handleSubmit(handleSaveDraft)();
                      }}
                    >
                      Save to Draft
                    </MDBBtn>
                  </>
                )}
              <span id="draftsuccess"></span>
              <div className="text-end">
                <MDBBtn
                  color="secondary"
                  className="me-2"
                  onClick={(e) => {
                    if (portingType === 3) {
                      setbackFlag(true);
                    }
                    handleBack();
                  }}
                  disabled={currentStep === 0}
                >
                  Back
                </MDBBtn>
                <MDBBtn
                  onClick={(e) => {
                    e.preventDefault();
                    handleForNext();
                  }}
                >
                  Next
                </MDBBtn>
              </div>
            </>
          )}
      </MDBModalFooter>
    </>
  );
}

export default UPloadCopyOfBill;
